// transaction.js

export class Transaction {
    constructor(app, card, taskCommit, taskFetch) {

        // public variables
        this.app = app
        this.card = card // card that created this transaction
        this.taskCommit = taskCommit
        this.taskFetch = taskFetch

        // private variables
        this._runable = true
        this._promise = null
        this._progressCallback = null
        this._errorCallback = null
        this._finishCallback = null
    }

    isRunable() {
        return this._runable
    }

    onProgress(callback) {
        this._progressCallback = callback
        return this
    }

    onError(callback) {
        this._errorCallback = callback
        return this
    }

    onFinish(callback) {
        this._finishCallback = callback
        return this
    }

    run() {
        if (this._promise) return this

        this._promise = (async () => {
            this.taskCommit.onProgress(message => {
                if (this._progressCallback) this._progressCallback(message)
            })
            this.taskCommit.run(this.app, this.card)
            const committed = await this.taskCommit.finished()
            this.card.assets = committed.assets
            this.taskFetch.onProgress((message, stage, assets) => {
                if (this._progressCallback) this._progressCallback(message, stage, assets)
            })
            this.taskFetch.run(this.app, this.card)
            const result = await this.taskFetch.finished()
            this._runable = false
            if (this._finishCallback) this._finishCallback(result.assets, result.stage)
            return result
        })()

        this._promise.catch(error => {
            this._runable = false
            if (this._errorCallback) this._errorCallback(error)
        }).catch(() => {})
        return this
    }

    finished() {
        return this._promise
    }
}
